import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

const generateMessage = (data) => {
  const hasData = data?.httpNonWww || data?.httpWww || data?.httpsNonWww || data?.httpsWww;
  if (!hasData) {
    return 'No urls were identified.';
  }
  return null;
};

const buildUrlTable = (data) => {
  const rows = [];
  const urlKeys = ['httpNonWww', 'httpWww', 'httpsNonWww', 'httpsWww'];

  urlKeys.forEach((key) => {
    const entry = data?.[key];
    if (entry) {
      rows.push({
        url: entry?.url || '',
        resolvedUrl: entry?.resolvedUrl || '-',
        statusCode: entry?.statusCode ?? '-',
      });
    }
  });

  return rows;
};

export const transformUrlResolve = (wwwResolveCriteria) => {
  if (!wwwResolveCriteria) {
    return {
      status: getStatus('neutral'),
      iconType: getIconType('neutral'),
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No urls were identified.',
      data: null,
    };
  }

  const data = wwwResolveCriteria?.data || {};
  const wooRankStatus = wwwResolveCriteria?.status || 'neutral';
  const importance = wwwResolveCriteria?.importance || 0;
  const solvability = wwwResolveCriteria?.solvability || 0;

  const urlTable = buildUrlTable(data);
  const isEmpty = urlTable.length === 0;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: generateMessage(data),
    data: isEmpty ? null : { urlTable },
  };
};

export default transformUrlResolve;

